import { ReactElement } from "react"

interface OptionallyVisibleProps {
  children: ReactElement
  visible: boolean
}
export const OptionallyVisible = ({
  children,
  visible,
}: OptionallyVisibleProps) => (visible ? children : null)
